import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Cards } from '@sorare/core/src/atoms/icons/Cards';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Root = styled(Vertical)`
  height: 100%;
  align-items: center;
  padding: var(--quadruple-unit) var(--double-unit);
  @media ${tabletAndAbove} {
    border-left: 1px solid var(--c-nd-150);
    padding: var(--quadruple-unit) var(--triple-unit);
  }
`;

export const Empty = () => {
  return (
    <Root className="text-center">
      <Cards size={3} />
      <FormattedMessage
        id="PlayerMarketDrawer.empty"
        defaultMessage="No cards on sale at the moment"
      />
    </Root>
  );
};
